import Typeahead from '@xo-union/tk-component-vendor-typeahead';
import { FieldProps, getIn } from 'formik';
import React from 'react';

export interface FormField extends FieldProps {
  label: string;
  'data-testid'?: string;
  onChange: (arg0: PlaceTypeaheadResponse) => void;
}

export interface PlaceTypeaheadResponse {
  formatted_address: string;
  formatted_phone_number: string;
  website: string;
  name: string;
}

const LOCATION_PROPERTIES = ['formatted_address', 'website', 'name', 'formatted_phone_number'];

const PlaceTypeahead: React.FC<FormField> = props => {
  const {
    label,
    field,
    form: { touched, errors, setFieldValue },
    onChange,
  } = props;

  const fieldTouched = getIn(touched, field.name);
  const error = getIn(errors, field.name);
  let state = 'neutral';
  let subText = '';

  if (fieldTouched && error) {
    state = 'invalid';
    subText = error;
  }

  return (
    <Typeahead
      source="google"
      locationProperties={LOCATION_PROPERTIES}
      label={label}
      defaultInputValue={field.value}
      onInputChange={(val: string) => {
        setFieldValue(field.name, val);
      }}
      onChange={onChange}
      state={state}
      subText={subText}
      data-testid={props['data-testid'] || 'place'}
    />
  );
};

export default PlaceTypeahead;
